import { type CreateOrUpdateAuthorModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<
    Pick<
      CreateOrUpdateAuthorModel,
      'nickname' | 'contactInfo' | 'description' | 'church'
    >
  >]: number
} = {
  nickname: 150,
  contactInfo: 1500,
  description: 2000,
  church: 200,
}
